//@ts-nocheck
import React, { ReactElement } from "react";
import { Query } from 'react-apollo'
import gql from "graphql-tag";
import { get } from "lodash";

const authorQuery = gql`
	query authorQuery($slug: String!) {

		author(slug: $slug) {
			id
			fullName
			shortBiography
			twitter
			instagram
			numStories
			picture {
				id
				url
			}
			slug
		}
	}
`;

interface Props {
	children: ({ author, loading, error }) => ReactElement
	slug: string
}

class AuthorId extends React.Component<Props> {
    
	parseData = data => ({
		author: get(data, "author", {}),
	});

	render() {
		return (
			<Query query={authorQuery} variables={{ slug: this.props.slug }}>
                {({ loading, data, error }) =>
                    this.props.children({ ...this.parseData(data), loading, error })
				}
			</Query>
		);
	}
}

export default AuthorId;
